{
    "firebase": {
        "apiKey": "AIzaSyClqKYOePpwnqVYRGVvETNZPbmTwljZMCk",
        "authDomain": "flightline-demo-3.firebaseapp.com",
        "databaseURL": "https://flightline-demo-3-default-rtdb.firebaseio.com",
        "projectId": "flightline-demo-3",
        "storageBucket": "flightline-demo-3.firebasestorage.app",
        "messagingSenderId": "376653444896",
        "appId": "1:376653444896:web:4b5654bad3f2205ecec945"
    },
    "clientName": "Berwind",
    "pdfViewerKey": "433bd4f70313453aacd60124900e6c20",
    "domains": ["berwind.flightlinedata.com"]
}
